import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { ClassChargeHistoryTable } from '~features/payment/ui/class-charge-history-table';

import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '~shared/shadcn/ui/card';

export const ClassChargeHistory = () => {
  return (
    <div className=''>
      <Link
        to='/payment/bulk-charge-students'
        className='flex items-center gap-2'
      >
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Class Charge History</h2>
      </Link>
      <div className='mt-8 border-t'>
        <Card className='mt-6'>
          <CardHeader>
            <CardTitle>Class Charge History</CardTitle>
            <CardDescription>
              View the history of charges made to students in this class.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <ClassChargeHistoryTable />
          </CardContent>
          <CardFooter>{/* Add your footer here */}</CardFooter>
        </Card>
      </div>
    </div>
  );
};
